import {Pipe, PipeTransform} from '@angular/core';
import {slugify} from '../../utils';

@Pipe({name: 'slugify'})
export class Slugify implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return slugify(value);
  }
}
